import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";

export async function ToggleVisibilityMarcaVehiculoAction(
  idCategoria: string
): Promise<ApiResponse<MarcaVehiculoInterface>> {
  const { data } = await apiClient.patch<MarcaVehiculoInterface>(
    `gvMarcaVehiculos/${idCategoria}/toggle-visibility`
  );
  return {
    status: 200,
    data,
    message:
      "Visibilidad de la marca de vehiculo actualizada correctamente",
  };
}
